const CustomerQueryKey = {
  SERVICE_CENTER: 'SERVICE_CENTER',
  FAQ: 'FAQ',
  NOTICE: 'NOTICE',
};

export default CustomerQueryKey;
